import React from 'react';
import { Modal, Descriptions, Tag, Divider, Table } from 'antd';

const ReportDetailModal = ({ visible, onClose, report }) => {
  if (!report) return null;

  const mockData = [];

  const columns = [
    { title: 'Metric', dataIndex: 'key', key: 'key' },
    { title: 'Value', dataIndex: 'value', key: 'value', render: (val) => <strong>{val}</strong> },
  ];

  return (
    <Modal
      title="Internal Report Details"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label="Report Name" span={2}>
          {report.reportName}
        </Descriptions.Item>
        <Descriptions.Item label="Report Type">
          {report.reportType}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={report.status === 'Approved' ? 'success' : 'warning'}>
            {report.status}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Start Date">
          {report.startDate}
        </Descriptions.Item>
        <Descriptions.Item label="End Date">
          {report.endDate}
        </Descriptions.Item>
        <Descriptions.Item label="Generated By">
          {report.generatedBy}
        </Descriptions.Item>
        <Descriptions.Item label="Generation Date">
          {report.generatedAt}
        </Descriptions.Item>
        {report.approvedBy && (
          <>
            <Descriptions.Item label="Approved By">
              {report.approvedBy}
            </Descriptions.Item>
            <Descriptions.Item label="Approval Date">
              {report.approvedAt}
            </Descriptions.Item>
          </>
        )}
      </Descriptions>

      <Divider>Report Data Summary</Divider>
      
      <Table 
        dataSource={mockData} 
        columns={columns} 
        pagination={false} 
        size="small" 
        style={{ marginBottom: '20px' }}
      />
      
      <div style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
        Note: Detailed breakdown can be found in the exported file (Excel/CSV).
      </div>
    </Modal>
  );
};

export default ReportDetailModal;
